module.exports = __webpack_public_path__ + "static/media/collage3.8530f756.png";